export class IconViewModel {
  Id: number = 0;
  Url: string;
  // UrlCross: string;
  // UrlDisabled: string;
  // Width: number;
  // Height: number;
  Color: string;

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Url = data["url"];
      // this.UrlCross = data["urlInactive"];
      // this.UrlDisabled = data["urlDisabled"];
      // this.Width = data["width"];
      // this.Height = data["height"];
      this.Color = data["color"];
    }
  }

  static fromJS(data: any): IconViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new IconViewModel();
    result.init(data);
    return result;
  }
}
